import Svg from "@/components/common/Svg";
import styles from "../Profile.module.css";

export interface ProfileTempOutPctlProps {
	value: number;
}

export default function ProfileTempOutPctl({
	value,
} : ProfileTempOutPctlProps) {

	return (
		value ?
			<div
				className={styles.ProfileTempOutPctl}
			>
				<div
					className={styles.ProfileTempOutPctlValue}
				>
					{value}%
				</div>
				<Svg
					aria-hidden={true}
					className={styles.ProfileTempOutPctlBar}
				>
					<rect
						x="0"
						y="0"
						rx="0.125em"
						width="100%"
						height="100%"
						className={styles.ProfileTempOutBarRectUnder}
					/>
					<rect
						x="0"
						y="0"
						rx="0.125em"
						width={`${value}%`}
						height="100%"
						className={styles.ProfileTempOutBarRectOver}
					/>
				</Svg>
			</div>
		: null
	);
}